export default __webpack_public_path__ + "static/media/bash.1ad8926f.jpg";